export class CustomDropdownFilterConfig {
  static readonly configs = [
    {
      annotation: 'metadata.annotations.backstage.io/apiOwnership',
      label: 'API Ownership'
    },
    {
       annotation: 'metadata.annotations.backstage.io/serviceScope',
       label: 'Service Scope'
    },
    {
      annotation: 'metadata.annotations.backstage.io/serviceCategory',
      label: 'Service Category'
    },
    {
      annotation: 'metadata.annotations.backstage.io/dmpDomain',
      label: 'Domain'
    },
    {
      annotation: 'metadata.title',
      label: 'Service/API'
    },
    {
      annotation: 'metadata.annotations.backstage.io/serviceOwner',
      label: 'Service Owner'
    },
    {
      annotation: 'metadata.annotations.backstage.io/productOwner',
      label: 'Product Owner'
    },
    {
      annotation: 'spec.owner',
      label: 'Team',
    },
    {
      annotation: 'metadata.annotations.backstage.io/apigeeProxy',
      label: 'Apigee Proxy'
    },
    {
      annotation: 'relations.dependencyOf',
      label: 'External Consumers'
    },
  ];
}